import ReduxConfirmModal from './ReduxConfirmModal';

export default ReduxConfirmModal;
